import $x from '@/utils/$x';

export async function queryLogin(params) {
  return $x.get(`/user/login`, params);
}

export async function logout() {
  return $x.get('/user/logout');
}

///TODO: change path
export async function queryOauthLogin(params) {
  return $x.get(`/user/login`, params);
}
